import {Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import {CompetitionRef} from "@/modules/competition/service/CompetitionService";
import {
    manageResultsService,
    PractitionerResult,
    Results,
    ResultsMenu,
    StartlistEntryRef
} from "@/modules/competition/service/ManageResultsService";
import {CompetitionTestRef, CompetitionTestSetRef} from "@/modules/competition/service/CompetitionTestsService";
import {
    useCompetitionPractitionerSearchHelper
} from "@/modules/competition/views/manage/components/CompetitionPractitionerSearchHelper";

@Module({namespaced: true, name: 'competition-manage-results'})
export default class CompetitionManageResultsModule extends VuexModule {
    menu: ResultsMenu = {} as ResultsMenu
    results: Results = {} as Results
    filter: string = ""
    filteredEntries: Array<PractitionerResult> = []

    @Mutation
    clearStore() {
        this.menu = {} as ResultsMenu
        this.results = {} as Results
        this.filter = ""
        this.filteredEntries = []
    }

    @MutationAction
    async loadData(ref: CompetitionRef) {
        const data = await manageResultsService.getData(ref)
        return {menu: data.menu, results: {} as Results, filteredEntries: new Array<PractitionerResult>(), filter: ""}
    }

    @MutationAction
    async select(request: SelectRequest) {
        const r = await manageResultsService.getResults(request.competition, request.testRef, request.testSetRef)
        return {results: r, filteredEntries: r.entries, filter: ""}
    }

    @Mutation
    async refresh(competitionRef: CompetitionRef) {
        this.results = await manageResultsService.getResults(competitionRef, this.results.testRef, this.results.testSet.ref!)
        this.filteredEntries = applyFilter(this.results, this.filter)
    }

    @Mutation
    async applySearchFilter(filter: string) {
        this.filter = filter
        this.filteredEntries = applyFilter(this.results, this.filter)
    }
}

function applyFilter(results: Results, filter: string): Array<PractitionerResult> {
    return useCompetitionPractitionerSearchHelper().search(results.entries, filter, (it) => it.practitioner)
}

export interface SelectRequest {
    competition: CompetitionRef
    testRef: CompetitionTestRef
    testSetRef: CompetitionTestSetRef
}

export interface SaveRawRequest {
    competitionRef: CompetitionRef
    testRef: CompetitionTestRef
    testSetRef: CompetitionTestSetRef
}

export interface DeleteResultRequest {
    competitionRef: CompetitionRef
    testRef: CompetitionTestRef
    testSetRef: CompetitionTestSetRef
    startlistEntryRef: StartlistEntryRef
}
